import React, { Component } from 'react';
import { isSubmitting } from 'redux-form';
import { connect } from 'react-redux';
import { AccentColor } from 'helpers/AccentColorHelper';

import AddExtraApplicantsDialog from './AddExtraApplicantsDialog';

import FlatButton from '@material-ui/core/Button';

let AddExtraApplicants = class extends Component {
  state = {
    dialogOpen: false,
  };

  toggleDialog = () => {
    this.setState(prevState => ({
      dialogOpen: !prevState.dialogOpen,
    }));
  };

  render() {
    const styles = {
      header: { textAlign: 'center', margin: '25px 0px 5px 0px' },
      subText: { textAlign: 'center', marginBottom: '15px' },
    };

    return (
      <div className="row" style={{ marginBottom: '25px' }}>
        <div>
          <h3 style={styles.header}>Extra Applicant(s)</h3>
          <p style={styles.subText}>
            If you believe you have missed adding, or would like to edit an existing applicant, you
            can do that here.
          </p>
        </div>

        <div style={{ textAlign: 'center' }}>
          <FlatButton
            onClick={this.toggleDialog}
            style={{ color: 'white', background: AccentColor() }}
          >
            Add/Edit Applicant(s)
          </FlatButton>
        </div>

        <AddExtraApplicantsDialog
          applicants={this.props.applicants}
          dialogOpen={this.state.dialogOpen}
          toggleDialog={this.toggleDialog}
          submit={this.props.submit}
        />
      </div>
    );
  }
};

export default connect(store => ({
  applicants: store.dashboard.applicants,
  isSubmitting: isSubmitting('add_applicants')(store),
}))(AddExtraApplicants);
